import usePermissions from 'hooks/usePermissions';
import { ContentLoading } from 'components/system/Loading';
import Page from 'components/system/Page';
import useAccountStore from 'store/accountStore';
import ActionableBanner from '../ActionableBanner';
import JobsTitle from './JobsTitle';
import JobsContent from './JobsContent';
import JobsFilters from './JobsFilters';

const userJobsColumns = [
  {
    key: 'jobName',
    label: 'Name',
  },
  {
    key: 'jobId',
    label: 'Job ID',
  },
  {
    key: 'runStatus',
    label: 'Status',
  },
  {
    key: 'device',
    label: 'Device',
  },
  {
    key: 'cost',
    label: 'Cost',
  },
  {
    key: 'createdOn',
    label: 'Start',
  },
  {
    key: 'runEnd',
    label: 'Finished Time',
  },
];

const UserJobs = ({
  jobs,
  total,
  isLoading,
  refetch,
  isRefetching,
  page,
  perPage,
  onPageChange,
  onRowsPerPageChange,
  onFilterChange,
  filters = {},
  handleSearch,
  searchQuery,
}) => {
  const { hasPermission } = usePermissions();

  const teamId = useAccountStore((state) => state.activeAccount.teamId);

  return (
    <Page
      title={<JobsTitle refetch={refetch} />}
    >
      {hasPermission('promo.banner') && <ActionableBanner />}
      {hasPermission('jobs.team.search') && (
        <JobsFilters
          teamId={teamId}
          onFilterChange={onFilterChange}
          filters={filters}
        />
      )}
      {
        (isLoading || isRefetching)
          ? (<ContentLoading />)
          : (
            <JobsContent
              columns={userJobsColumns}
              jobs={jobs}
              page={page}
              total={total}
              rowsPerPage={perPage}
              setPage={onPageChange}
              setRowsPerPage={onRowsPerPageChange}
              handleSearch={handleSearch}
              searchQuery={searchQuery}
              onFilterChange={onFilterChange}
              filters={filters}
            />
          )
      }
    </Page>
  );
};

export default UserJobs;
